<!-- News Manager Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">News Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-news-manager-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add News Item Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddNewsItemModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add News Item
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Form -->
  <div class="card-body border-top pt-6" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row mb-6">
      <div class="col-md-4">
        <label class="form-label">Search</label>
        <input type="text" class="form-control form-control-solid" placeholder="Search news items..."
               [(ngModel)]="searchTerm" (keyup.enter)="applyFilters()">
      </div>
      <div class="col-md-4">
        <label class="form-label">Show Status</label>
        <select class="form-select form-select-solid" [(ngModel)]="filters.show">
          <option value="">All</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button type="button" class="btn btn-primary me-2" (click)="applyFilters()">Apply Filters</button>
        <button type="button" class="btn btn-secondary" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="card-body pt-0">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && newsItems.length === 0" class="text-center py-10">
      <div class="mb-5">
        <i class="ki-duotone ki-file-deleted fs-5x text-muted">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <h5 class="text-muted">No news items found</h5>
      <p class="text-muted">Create your first news item to get started</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && newsItems.length > 0" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-10px pe-2">
              <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input class="form-check-input" type="checkbox"
                       [checked]="isAllSelected()"
                       [indeterminate]="isIndeterminate()"
                       (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-200px">News Title</th>
            <th class="min-w-100px">Show</th>
            <th class="min-w-100px">Start Date</th>
            <th class="min-w-100px">Expiry Date</th>
            <th class="min-w-100px">Created Date</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let newsItem of newsItems; trackBy: trackByFn">
            <td>
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="newsItem._id"
                  [checked]="isSelected(newsItem._id)"
                  (change)="toggleSelection(newsItem._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ newsItem.news_title || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="badge"
                    [class]="newsItem.show ? 'badge-light-success' : 'badge-light-danger'">
                {{ getStatusDisplay(newsItem.show) }}
              </span>
            </td>
            <td>{{ formatDate(newsItem.start_date) }}</td>
            <td>{{ formatDate(newsItem.expiry_date) }}</td>
            <td>{{ formatDate(newsItem.created_at) }}</td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(newsItem)"
                  title="Edit News Item">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteNewsItem(newsItem)"
                  title="Delete News Item">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && newsItems.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- News Manager Add/Edit Modal -->
<app-add-edit-news-manager
  (newsItemAdded)="onNewsItemAdded()"
  (newsItemUpdated)="onNewsItemUpdated()">
</app-add-edit-news-manager>
